import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import theme from "assets/theme";

import routes from "routes";
import DetalleProducto from "pages/LandingPages/DetalleProducto";
import Cancelacion from "pages/LandingPages/Recursos/cancelacion";
import Privacidad from "pages/LandingPages/Recursos/privacidad";
import Sensibles from "pages/LandingPages/Recursos/sensibles";

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {getRoutes(routes)}
        <Route exact path="/producto/detalle" element={<DetalleProducto />} />
        <Route exact path="/cancelacion" element={<Cancelacion />} />
        <Route exact path="/privacidad" element={<Privacidad />} />
        <Route exact path="/sensibles" element={<Sensibles />} />
        <Route path="*" element={<Navigate to="/inicio" />} />
      </Routes>
    </ThemeProvider>
  );
}
